import script from "./MoreInfoProducts.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoreInfoProducts.component.vue?vue&type=script&lang=ts&setup=true"

import "./MoreInfoProducts.component.vue?vue&type=style&index=0&id=d86e4948&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d86e4948"]])

export default __exports__